import { getEnvironment } from '@/helpers/environment'

const FLAGS = {
  defaults: {
    debugBar: false,
    'owner-services-mfe': true,
    'owner-services-mfe-contact-us': true,
    'web-chat-test': false,
    'vite': true,
    'web-app-redirect': true
  },
  localhost: {
    debugBar: true,
    'owner-services-mfe': true,
    'owner-services-mfe-contact-us': false,
    'web-chat-test': true,
    'web-app-redirect': true
  },
  dev: {
    debugBar: true,
    'owner-services-mfe': true,
    'owner-services-mfe-contact-us': false,
    'web-chat-test': true,
    'web-app-redirect': true
  },
  ppe: {
    debugBar: false,
    'owner-services-mfe': true,
    'owner-services-mfe-contact-us': true,
    'web-chat-test': true,
    'web-app-redirect': true
  }
}

export function isEnabled (flag, flags = FLAGS) {
  const environment = getEnvironment()

  const environmentFlags = {
    ...flags.defaults,
    ...flags[environment]
  }

  return environmentFlags[flag]
}
